var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEGeneralRoomUnitT = function SvgEGeneralRoomUnitT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 397,
    width: 28,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,398v26h-26v-26h26M415,397h-28v28h28v-28h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.51,422.74h-7.9c-.86,0-1.55-.69-1.55-1.55v-7.16c0-.93.75-1.68,1.68-1.68h7.63c.93,0,1.68.75,1.68,1.68v7.16c0,.86-.69,1.55-1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.39 418.47 394.56 414.75 391.73 418.47 393.55 418.47 393.55 420.34 395.57 420.34 395.57 418.47 397.39 418.47",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.39,422.74h-7.9c-.86,0-1.55-.69-1.55-1.55v-7.16c0-.93.75-1.68,1.68-1.68h7.63c.93,0,1.68.75,1.68,1.68v7.16c0,.86-.69,1.55-1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.27 416.62 407.44 420.34 404.61 416.62 406.43 416.62 406.43 414.75 408.45 414.75 408.45 416.62 410.27 416.62",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M410.19,407.21c0-.16-.13-.29-.29-.29s-.29.13-.29.29.13.29.29.29.29-.13.29-.29",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.45,407.7h1.67c.23,0,.46,0,.66-.05.02,0,.03,0,.05-.01l-.12-.67h-2.9l-.55.32c.1.14.24.26.41.33.23.09.51.09.78.09",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.2,403.38c-.08.12-.12.26-.12.41v2.54c0,.28,0,.55.09.78.01.03.03.06.04.09,0,.01.01.03.02.04l.58-.33v-3.17l-.61-.35Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,403.23l.49-.28h2.95l.49.28s.03.02.04.03c.03.05,0,.11-.04.13l-.49.28h-2.95l-.49-.28s-.03-.02-.04-.04c-.03-.05,0-.11.04-.13",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.5,400.73v2.1c0,.15-.04.29-.12.41l-.61-.35v-2.89l.21-.59c.19.11.34.28.43.48.1.25.1.54.1.84",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.93,399.39s-.01,0-.02,0c0,0-.01,0-.02-.01,0,0-.02,0-.03,0-.24-.1-.54-.1-.84-.1h-1.47c-.3,0-.59,0-.84.1-.14.06-.27.15-.37.26,0,.01-.02.03-.03.04l.59.34h2.8l.22-.61Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path162",
    d: "M405.75,407.7h1.67c.23,0,.46,0,.66-.05.02,0,.03,0,.05-.01l-.12-.67h-2.9l-.55.32c.1.14.24.26.41.33.23.09.51.09.78.09",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path166",
    d: "M404.5,403.38c-.08.12-.12.26-.12.41v2.54c0,.28,0,.55.09.78.01.03.03.06.04.09,0,.01.01.03.02.04l.58-.33v-3.17l-.61-.35Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path168",
    d: "M404.62,403.23l.49-.28h2.95l.49.28s.03.02.04.03c.03.05,0,.11-.04.13l-.49.28h-2.95l-.49-.28s-.03-.02-.04-.04c-.03-.05,0-.11.04-.13",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path170",
    d: "M408.79,400.73v2.1c0,.15-.04.29-.12.41l-.61-.35v-2.89l.21-.59c.19.11.34.28.43.48.1.25.1.54.1.84",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path174",
    d: "M408.23,399.39s-.01,0-.02,0c0,0-.01,0-.02-.01,0,0-.02,0-.03,0-.24-.1-.54-.1-.84-.1h-1.47c-.3,0-.59,0-.84.1-.14.06-.27.15-.37.26,0,.01-.02.03-.03.04l.59.34h2.8l.22-.61Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.12,403.68h.87c.12,0,.24,0,.34-.03,0,0,.02,0,.03,0l-.06-.35h-1.52l-.29.17c.05.08.13.14.21.17.12.05.26.05.41.05",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.72,402.96v-1.33c0-.07-.02-.15-.07-.21l-.32.18v1.69l.06.34s0,0,.01,0c.12-.05.21-.14.26-.26.05-.12.05-.26.05-.41",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,401.42c-.04.06-.06.14-.06.21v1.33c0,.14,0,.29.05.41,0,.02.01.03.02.05,0,0,0,.01.01.02l.3-.17v-1.66l-.32-.19Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.72,400.03v1.1c0,.08-.02.15-.07.21l-.32-.18v-1.51l.11-.31c.1.06.18.15.22.25.05.13.05.28.05.44",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.4,400.03v1.1c0,.08.02.15.06.21l.32-.18v-1.51l-.28-.16s-.04.07-.06.11c-.05.13-.05.28-.05.44",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,399.33s0,0-.01,0c0,0,0,0-.01,0,0,0,0,0-.01,0-.13-.05-.28-.05-.44-.05h-.77c-.15,0-.31,0-.44.05-.07.03-.14.08-.19.13,0,0-.01.01-.02.02l.31.18h1.46l.12-.32Z",
    fill: "#080f15"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 410,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 398,
    width: 26,
    height: 26,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 411,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,401c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M434,400c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.21,408.41h-1.77v4.89h-.98v-4.89h-1.76v-.8h4.51v.8Z"
  })))));
};
export default SvgEGeneralRoomUnitT;